import { takeEvery } from 'redux-saga'
import { put, select, call } from 'redux-saga/effects'
import { copyCameraSelector } from 'selectors'
import { COPY_CAMERA, duplicateCameraAction, addRecentModelAction } from 'actions/cameraActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import determineLocationOfNewDevice from 'helpers/map/determineLocationOfNewDevice'

export function * copyCamera(action) {
  try {
    const { cameras, map, isImperial, devices } = yield select(copyCameraSelector)

    const location = yield call(determineLocationOfNewDevice, { map, devices, isImperial })
    const camera = cameras.find(c => c.id === action.id)

    yield put(duplicateCameraAction(action.id, location))

    if (camera && camera.model) {
      yield put(addRecentModelAction(camera.model.id, Date.now()))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for duplicate camera action, then call function */
export function * watchCopyCamera() {
  yield * takeEvery(COPY_CAMERA, copyCamera)
}



// WEBPACK FOOTER //
// ./src/sagas/copyCameraSaga.js